module.exports = __webpack_public_path__ + "img/banner2024.8aa8d490.jpg";